<template>
  <div class="search-page">
    <div class="nav">
      <router-link to="/search">Search Term</router-link>
      <router-link to="/a-z" class="is-active">A-Z Listing</router-link>
    </div>
    <div
      class="inputs__container search-results search-results--square-right">
      <div>
        <div class="text--muted pb-2">Browse an alphabetical listing of all terms</div>
        <form class="alpha-pager">
          <ubc-btn input-type="radio" input-value="A" v-model="currentPage" @click="alphaSearch('a')">A</ubc-btn>
          <ubc-btn input-type="radio" input-value="B" v-model="currentPage" @click="alphaSearch('b')">B</ubc-btn>
          <ubc-btn input-type="radio" input-value="C" v-model="currentPage" @click="alphaSearch('c')">C</ubc-btn>
          <ubc-btn input-type="radio" input-value="D" v-model="currentPage" @click="alphaSearch('d')">D</ubc-btn>
          <ubc-btn input-type="radio" input-value="E" v-model="currentPage" @click="alphaSearch('e')">E</ubc-btn>
          <ubc-btn input-type="radio" input-value="F" v-model="currentPage" @click="alphaSearch('f')">F</ubc-btn>
          <ubc-btn input-type="radio" input-value="G" v-model="currentPage" @click="alphaSearch('g')">G</ubc-btn>
          <ubc-btn input-type="radio" input-value="H" v-model="currentPage" @click="alphaSearch('h')">H</ubc-btn>
          <ubc-btn input-type="radio" input-value="I" v-model="currentPage" @click="alphaSearch('i')">I</ubc-btn>
          <ubc-btn input-type="radio" input-value="J" v-model="currentPage" @click="alphaSearch('j')">J</ubc-btn>
          <ubc-btn input-type="radio" input-value="K" v-model="currentPage" @click="alphaSearch('k')">K</ubc-btn>
          <ubc-btn input-type="radio" input-value="L" v-model="currentPage" @click="alphaSearch('l')">L</ubc-btn>
          <ubc-btn input-type="radio" input-value="M" v-model="currentPage" @click="alphaSearch('m')">M</ubc-btn>
          <ubc-btn input-type="radio" input-value="N" v-model="currentPage" @click="alphaSearch('n')">N</ubc-btn>
          <ubc-btn input-type="radio" input-value="O" v-model="currentPage" @click="alphaSearch('o')">O</ubc-btn>
          <ubc-btn input-type="radio" input-value="P" v-model="currentPage" @click="alphaSearch('p')">P</ubc-btn>
          <ubc-btn input-type="radio" input-value="Q" v-model="currentPage" @click="alphaSearch('q')">Q</ubc-btn>
          <ubc-btn input-type="radio" input-value="R" v-model="currentPage" @click="alphaSearch('r')">R</ubc-btn>
          <ubc-btn input-type="radio" input-value="S" v-model="currentPage" @click="alphaSearch('s')">S</ubc-btn>
          <ubc-btn input-type="radio" input-value="T" v-model="currentPage" @click="alphaSearch('t')">T</ubc-btn>
          <ubc-btn input-type="radio" input-value="U" v-model="currentPage" @click="alphaSearch('u')">U</ubc-btn>
          <ubc-btn input-type="radio" input-value="V" v-model="currentPage" @click="alphaSearch('v')">V</ubc-btn>
          <ubc-btn input-type="radio" input-value="W" v-model="currentPage" @click="alphaSearch('w')">W</ubc-btn>
          <ubc-btn input-type="radio" input-value="X" v-model="currentPage" @click="alphaSearch('x')">X</ubc-btn>
          <ubc-btn input-type="radio" input-value="Y" v-model="currentPage" @click="alphaSearch('y')">Y</ubc-btn>
          <ubc-btn input-type="radio" input-value="Z" v-model="currentPage" @click="alphaSearch('z')">Z</ubc-btn>
          <ubc-btn input-type="radio" input-value="#" v-model="currentPage" @click="numberSearch('#')">#</ubc-btn>
        </form>
        <div class="text--right text--muted pt-2">Currently viewing: <strong>{{currentPage}}</strong></div>
      </div>
    </div>
    <div class="search-results">
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment. Please try back later.</p>
      </section>
      <template
        v-if="(loading && !errored)">
        <p class="loading">
          <img
            class="loading__icon"
            src="../assets/loader.svg" />
        </p>
      </template>
      <div
        class="relative"
        v-if="(noResultsMsg && !loading)">
        <p>No Results. Please try another search.</p>
      </div>
      <p
        v-if="(!showResults && !loading && !errored)">Please select the first letter of the term to begin browsing.</p>
      <div ref="layout">
        <div class="md--flex width--full" v-if="(showResults && !noResultsMsg && !loading)">
          <div class="block md--flex-1 mr-0">
            <input
              id="search-within"
              name="query"
              autocomplete="off"
              placeholder="Filter search results by a keyword..."
              class="form-control form-control--small"
              v-model="filterKey">
            <button
              class="button__clear button__clear--small"
              title="Clear Results"
              v-if="showResults"
              @click="clearFilter()">&times;</button>
          </div>
          <ubc-dropdown ref="dropdown" class="block md--flex-1">
            <button type="plain" class="dropdown-toggle block">Filter by{{ filterByText }} <span class="caret float-right"></span></button>
            <template slot="dropdown">
              <li><ubc-btn input-type="radio" input-value="" v-model="filterSelect" @click="filterByText = '...'">No Filter</ubc-btn></li>
              <li><ubc-btn input-type="radio" input-value="low" v-model="filterSelect" @click="filterByText = ' Low Risk'">Filter By Low Risk</ubc-btn></li>
              <li><ubc-btn input-type="radio" input-value="medium" v-model="filterSelect" @click="filterByText = ' Medium Risk'">Filter By Medium Risk</ubc-btn></li>
              <li><ubc-btn input-type="radio" input-value="high" v-model="filterSelect" @click="filterByText = ' High Risk'">Filter By High Risk</ubc-btn></li>
              <li><ubc-btn input-type="radio" input-value="very" v-model="filterSelect" @click="filterByText = ' Very High Risk'">Filter By Very High Risk</ubc-btn></li>
            </template>
          </ubc-dropdown>
          <ubc-dropdown ref="dropdown" class="block md--flex-1">
            <button class="dropdown-toggle block">Sort by{{ sortByText }} <span class="caret float-right"></span></button>
            <template slot="dropdown">
              <li><a role="button" @click="sort('name', 'asc'); sortByText = '...'">Sort by Alphabetical</a></li>
              <li><a role="button" @click="sort('status', 'asc'); sortByText = ' Status'">Sort by Status</a></li>
              <li><a role="button" @click="sort('lastUpdated', 'desc'); sortByText = ' Last Modified'">Sort by Last Modified</a></li>
            </template>
          </ubc-dropdown>
        </div>
        <paginate-links
          class="unstyled-list"
          v-if="(showResults && !noResultsMsg && !loading)"
          for="filteredData"
          :hide-single-page="true"
          :async="true">
        </paginate-links>
        <paginate
          class="search-results-wrapper unstyled-list"
          name="filteredData"
          v-if="(showResults && !noResultsMsg  && !loading)"
          :list="filteredData"
          :per="10"
          :container="this"
          ref="paginator">
          <li
            class="search-result"
            v-for="result in paginated('filteredData')"
            :class="result.sensitivity | lowercase() | dashSeparated()"
            v-bind:key="result.id">
            <h3 class="search-result__title">{{ result.name }}</h3>
            <nav class="crumbs">{{ result.community.name }} > <a @click="glossarySearch(result.glossary.name)" class="breadcrumb-link">{{ result.glossary.name }}</a>
            </nav>
            <div><strong>Security Classification: {{ result.sensitivity }}</strong></div>
            <p class="text--hug">{{ result.definition }}</p>
            <dl class="mb-0">
              <dt>Data Steward:</dt>
              <dd>
                <template v-for="(steward, index) in result.stewards">{{ steward.name }}<span v-if="index+1 < result.stewards.length" v-bind:key="index">, </span>
                </template>
              </dd>
              <dt>Data Community:</dt>
              <dd>{{ result.community.name }}</dd>
              <dt>Last Updated:</dt>
              <dd>{{ result.lastUpdated }}</dd>
              <dt>Status:</dt>
              <dd>{{ result.status }}</dd>
            </dl>
            <Toggle v-bind:result="result" v-bind:key="result.id" @selected="autoSearchOnLoad"></Toggle>
          </li>
        </paginate>
        <paginate-links
          class="unstyled-list"
          v-if="(showResults && !noResultsMsg && !loading)"
          for="filteredData"
          :hide-single-page="true"
          :async="true">
        </paginate-links>
        <span
          class="block pt-2"
          v-if="(showResults && !noResultsMsg && $refs.paginator  && !loading)">Viewing {{$refs.paginator.pageItemsCount}} results</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Toggle from '@/components/Toggle'
import StyledButton from '@/components/StyledButton'

export default {
  name: 'a-z',
  components: {
    Toggle,
    StyledButton
  },
  props: {
    alphaquery: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentSort: 'name',
      currentSortDir: 'asc',
      currentPage: 'None',
      errored: false,
      filterByText: '...',
      filterCategory: '',
      filterKey: '',
      filterSelect: '',
      isActive: false,
      loading: false,
      noResultsMsg: false,
      paginate: ['filteredData'],
      results: [],
      searchText: '',
      searchQuery: '',
      showResults: false,
      sortByText: '...'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // access to component's instance using `vm`. this is done because this navigation guard is called before the component is created.
      // re-populate search result arguments and trigger methods
      if (vm.alphaquery) {
        vm.letter = vm.alphaquery
        vm.alphaSearch(vm.letter)
      }
      next()
    })
  },
  methods: {
    // returns match for selected glossary breadcrumb link
    alphaSearch (letter) {
      this.loading = true
      var glossaryLink = letter
      axios
        .get('https://cio.ubc.ca/edgconnect/term/alpha/' + glossaryLink)
        .then(res => {
          if (res.data.response) {
            this.loading = false
            this.noResultsMsg = true
          } else {
            this.$router.push({
              query: { ...this.$route.alphaquery, alpha: letter }
            })
            this.noResultsMsg = false
            this.loading = false
            this.showResults = true
            this.results = res.data.pageItems
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
    },
    numberSearch (letter) {
      this.loading = true
      var glossaryLink = letter
      axios
        .get('https://cio.ubc.ca/edgconnect/term/alphaOther/' + glossaryLink)
        .then(res => {
          if (res.data.response) {
            this.loading = false
            this.noResultsMsg = true
          } else {
            this.$router.push({
              query: { ...this.$route.alphaquery, alpha: letter }
            })
            this.noResultsMsg = false
            this.loading = false
            this.showResults = true
            this.results = res.data.pageItems
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
    },
    // returns match for selected glossary breadcrumb link
    glossarySearch (id) {
      this.$router.push({
        path: 'search', query: { glossary: id }
      })
    },
    // returns UID match from links in Search toggle
    autoSearchOnLoad (selected) {
      this.$router.push({
        path: 'search', query: { uid: selected }
      })
    },
    /*
    // returns match for selected community breadcrumb link
    communitySearch (term) {
      this.$router.push({
        path: 'search', query: { community: term }
      })
    },
    */
    sort (sortby, dir) {
      this.currentSort = sortby
      this.currentSortDir = dir
    },
    clearFilter () {
      this.filterKey = ''
    }
  },
  computed: {
    filteredData () {
      var currentSort = this.currentSort
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var filterSelect = this.filterSelect && this.filterSelect.toLowerCase()
      var data = this.results
      // filter text input
      if (filterKey) {
        data = data.filter((row) => {
          return Object.keys(row).some((key) => {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      // filter options
      if (filterSelect) {
        data = data.filter((row) => {
          // truncate to first word (otherwise very high risk also matches high risk)
          var risk = row.sensitivity.replace(/ .*/, '')
          return risk.toLowerCase()
            .indexOf(filterSelect) > -1
        })
      }
      // sort options
      if (currentSort) {
        data = data.slice().sort((a, b) => {
          let modifier = 1
          if (this.currentSortDir === 'desc') modifier = -1
          if (a[currentSort] < b[currentSort]) return -1 * modifier
          if (a[currentSort] > b[currentSort]) return 1 * modifier
          return 0
        })
      }
      return data
    }
  }
}
</script>

<style scoped lang="scss">
.form-control {
  margin-bottom: 0;
  height: 46px;
  flex: 1;
  min-width: 140px;
  border-radius: 5px 0 0 5px;
  font-size: 16px;
  border: 1px solid rgba($color: #000000, $alpha: .1);
  transition: border .125s ease;
  &--small {
    width: 100%;
    height: 30px;
    font-size: 14px;
    padding-left: .5rem;
    margin-bottom: 1rem;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #ddd;
  }
  &.focus {
    border: 1px solid rgba($color: #002145, $alpha: .6);
  }
}

.float-right {
  float: right;
  color: black;
}
.dropdown-toggle {
  width: 100%;
  text-align: left;
}
.loading {
  text-align: center;
  &__icon {
    display: inline-block;
    width: 100px;
    height: 100px;
  }
}

// BUTTONS
// reset clf button
.btn,
.btn.active {
  background-color: #fff;
  display: block;
  text-align: left;
  border: none;
  background-image: none;
  color: #333;
  transition: color .125s ease;
  box-shadow:none;
  &:hover {
    color: #fff;
    background-color: #002145;
  }
}

.alpha-pager {
  display: flex;
  flex-wrap: wrap;
}
.btn,
button {
  color: #333;
  background-image: none;
  border: none;
  padding: .5rem .95rem;
  margin: 0 .1rem .1rem 0;
  background-color: transparent;
  border-radius: 2px;
  box-shadow: 2px 2px 2px rgba(0,0,0,0.08);
  transition: all .125s ease;
  &:hover {
    background-color: rgba($color:#002145, $alpha: .3);
    color: #2c3e50;
  }
  &.active {
    background-color: #002145;
    color: #fff;
  }
}
input[type=radio] {
  display: none;
}
.button__clear--small {
  order: 2;
  font-weight: bold;
  background: none;
  border: none;
  margin-left: -25px;
  align-self: center;
  position: relative;
  box-shadow: none;
  height: 30px;
  margin-bottom: 1rem;
  padding: .25rem;
  &:hover {
    background-color: transparent;
  }
}
.button__noresults {
  display: inline-block;
  border: 1px solid #002145;
  border-radius: 2px;
  position: absolute;
  right: 0;
}
// DROPDOWN MENU
.dropdown-toggle {
  color: #2c3e50;
  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
}
.dropdown-menu {
  li {
    width: 100%;
    margin: 0;
    text-align: left;
  }
  label {
    border-radius: 0;
    padding: .25rem .5rem;
    margin: 0;
    &:hover {
      background-color: #002145;
      color: #fff;
    }
    &.active {
      color: #333;
      background-color: #fff;
    }
  }
}
input[type=radio] {
  display: none;
}
</style>
